import $ from 'jquery';

$(function () {
    $(document).on('keyup', ':input[data-create-new][data-create-new-collection]', function (e, force) {
        var $this = $(this),
            itemSelector = $this.attr('data-create-new'),
            collectionSelector = $this.attr('data-create-new-collection');

        var item = $this.closest(itemSelector),
            collection = item.closest(collectionSelector).find(itemSelector);

        if (collection.last().get(0) !== item.get(0)) {
            return;
        }

        if (force || ($this.val() + '').trim()) {
            var clone = item.clone(),
                counter = item.data('collection-counter');

            counter = counter ? parseInt(counter, 10) : false;

            var defaultPattern = '^(.*?\\[)([^\\]]+)(\\].*)$',
                namePattern = $this.attr('data-create-new-pattern'),
                nameRegexp = new RegExp(namePattern || defaultPattern, 'i'),
                idPattern = $this.attr('data-create-new-id-pattern');

            clone.find(':input').each(function () {
                var $input = $(this);
                var nameRegexpForInput = nameRegexp;
                if ($input.attr('data-create-new-pattern')) {
                    nameRegexpForInput = new RegExp($input.attr('data-create-new-pattern') || defaultPattern, 'i');
                }

                $input.attr('name', $input.attr('name').replace(nameRegexpForInput, function (match, start, index, end) {
                    counter = counter === false ? parseInt(index, 10) : counter;
                    return start + (counter + 1) + end;
                }));

                var oldId = $input.attr('id'),
                    newId = $input.attr('name').replace(/[^a-z0-9_]+/ig, '_');
                if (oldId) {
                    var idPatternForInput = idPattern;
                    if ($input.attr('data-create-new-id-pattern')) {
                        idPatternForInput = $input.attr('data-create-new-id-pattern');
                    }
                    if (idPatternForInput) {
                        var idRegexp = new RegExp(idPattern, 'i');
                        newId = $input.attr('id').replace(idRegexp, function (match, start, index, end) {
                            counter = counter === false ? parseInt(index, 10) : counter;
                            return start + (counter + 1) + end;
                        });
                    }
                    clone.find('label[for="' + oldId + '"]').attr('for', newId);
                }
                $input.attr('id', newId);
            });
            clone.find(':input:not([type=checkbox]):not([type=radio])').val('');
            clone.find('input[type=checkbox], input[type=radio]').removeAttr('checked').prop('checked', false);

            item.data('collection-counter', ++counter);

            item.after(clone);
        }
    });
});
